import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import ContentWrapper from '../components/contentwrapper/ContentWrapper';
import { useNavigate } from 'react-router-dom';
import { getSingleDataFromDatabase, userUploadProfilePicAPI } from '../utils/api';
import { toast } from 'react-toastify';
import { BASEURLS } from '../utils/BaseUrl';
import { MdCloudUpload, MdEmail, MdPhone, MdAccessTime, MdVerified, MdSecurity, MdTipsAndUpdates } from "react-icons/md";
import { FaUserCircle, FaShieldAlt, FaRegCheckCircle } from "react-icons/fa";
import { IoTrendingUp } from "react-icons/io5";
import withAuth from '../utils/withAuth';

const MyProfile = () => {
    const subagentid = localStorage.getItem('subagentdata');
    const [subagent, setSubagent] = useState([]);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState('');
    const [uploading, setUploading] = useState(false);
    const [imgError, setImgError] = useState(false);

    useEffect(() => {
        if (subagentid) {
            getDashboardSingleEmpData(subagentid);
        } else {
            navigate("/");
        }
    }, [subagentid]);

    const getDashboardSingleEmpData = (subagentid) => {
        setIsLoading(true);
        getSingleDataFromDatabase(`sub-agent-get-single-data/${subagentid}`)
            .then((res) => {
                if (res.data.status === 1) {
                    setSubagent(...[res.data.subagentdata]);
                } else {
                    toast.error("Check your connection");
                }
            })
            .catch(() => toast.error("Connection failed!"))
            .finally(() => setIsLoading(false));
    }

    useEffect(() => {
        if (file) {
            setUploading(true);
            try {
                const data = new FormData();
                data.append("subagent_foto", file);
                userUploadProfilePicAPI(`sub-agent-upload-profile-pic/${subagentid}`, data)
                    .then((res) => {
                        if (res.data.status === 1) {
                            toast.success("Profile picture updated successfully!");
                            window.location.reload();
                        } else {
                            toast.error("Unable to update picture");
                        }
                    })
                    .catch(() => toast.error("Upload failed!"))
                    .finally(() => setUploading(false));
            } catch (error) {
                toast.error("Connection failed!");
                setUploading(false);
            }
        }
    }, [file]);

    const getInitials = (name) => {
        if (!name) return "SA";
        return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
    }

    const SkeletonBlock = ({ width = "100%", height = "16px", radius = "6px", mb = "12px" }) => (
        <div style={{
            width, height, borderRadius: radius,
            background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
            backgroundSize: "200% 100%",
            animation: "shimmer 1.5s infinite",
            marginBottom: mb
        }} />
    );

    const tips = [
        { icon: <FaRegCheckCircle />, color: "#4e9191", text: "Keep your mobile number updated for OTP login." },
        { icon: <MdSecurity />, color: "#0e7c52", text: "Never share your OTP or login credentials with anyone." },
        { icon: <IoTrendingUp />, color: "#c779db", text: "Check your dashboard daily to track order performance." },
        { icon: <MdTipsAndUpdates />, color: "#f59e0b", text: "Update your profile picture for easy identification." },
    ];

    const accountDetails = [
        { label: "Account Type", value: "Sub Agent" },
        { label: "Account Status", value: "Active ✅" },
        { label: "Agent ID", value: `#${subagentid?.slice(0, 8) || "—"}` },
        { label: "Platform", value: "Satkartar CRM" },
    ];

    return (
        <div className="myprofile">
            <Helmet>
                <title>SATKARTAR:SUB AGENT::MY PROFILE</title>
            </Helmet>

            <style>{`
                @keyframes shimmer {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .profile-card {
                    animation: fadeInUp 0.5s ease;
                    border: none !important;
                    box-shadow: 0 10px 40px rgba(0,0,0,0.08) !important;
                    border-radius: 20px !important;
                    overflow: hidden !important;
                    height: 100%;
                }
                .profile-banner {
                    height: 120px;
                    background: linear-gradient(135deg, #4e9191 0%, #0e7c52 50%, #597e0d 100%);
                    position: relative;
                }
                .profile-banner::after {
                    content: '';
                    position: absolute;
                    bottom: 0; left: 0; right: 0;
                    height: 40px;
                    background: white;
                    border-radius: 40px 40px 0 0;
                }
                .profile-avatar-wrap {
                    position: relative;
                    display: inline-block;
                    margin-top: -55px;
                    z-index: 2;
                }
                .profile-avatar {
                    width: 110px; height: 110px;
                    border-radius: 50%;
                    border: 4px solid white;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
                    object-fit: cover;
                }
                .avatar-initials {
                    width: 110px; height: 110px;
                    border-radius: 50%;
                    border: 4px solid white;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
                    background: linear-gradient(135deg, #4e9191, #0e7c52);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 36px;
                    font-weight: 700;
                    color: white;
                }
                .upload-overlay {
                    position: absolute;
                    bottom: 4px; right: 4px;
                    width: 32px; height: 32px;
                    border-radius: 50%;
                    background: #4e9191;
                    border: 3px solid white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s;
                    box-shadow: 0 2px 8px rgba(0,0,0,0.2);
                }
                .upload-overlay:hover { background: #0e7c52; transform: scale(1.1); }
                .upload-overlay input { display: none; }
                .info-row {
                    display: flex;
                    align-items: center;
                    padding: 13px 0;
                    border-bottom: 1px solid #f5f5f5;
                    transition: all 0.2s;
                }
                .info-row:last-child { border-bottom: none; }
                .info-row:hover { background: #fafafa; border-radius: 10px; padding-left: 8px; }
                .info-icon {
                    width: 38px; height: 38px;
                    border-radius: 10px;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 18px;
                    margin-right: 14px;
                    flex-shrink: 0;
                }
                .info-label { font-size: 11px; color: #aaa; font-weight: 500; text-transform: uppercase; letter-spacing: 0.5px; margin: 0; }
                .info-value { font-size: 14px; color: #333; font-weight: 600; margin: 2px 0 0 0; }
                .badge-active {
                    display: inline-flex; align-items: center; gap: 4px;
                    background: #e8f5e9; color: #2e7d32;
                    font-size: 11px; font-weight: 600;
                    padding: 3px 10px; border-radius: 20px;
                }
                .right-card {
                    animation: fadeInUp 0.6s ease;
                    border: none !important;
                    box-shadow: 0 10px 40px rgba(0,0,0,0.08) !important;
                    border-radius: 20px !important;
                    padding: 20px;
                    margin-bottom: 16px;
                }
                .tip-item {
                    display: flex; align-items: flex-start; gap: 12px;
                    padding: 12px;
                    border-radius: 12px;
                    background: #f8f9fa;
                    margin-bottom: 10px;
                    transition: all 0.2s;
                }
                .tip-item:hover { transform: translateX(4px); background: #f0fafa; }
                .tip-icon {
                    width: 34px; height: 34px; border-radius: 10px;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 16px; flex-shrink: 0;
                }
                .account-row {
                    display: flex; justify-content: space-between; align-items: center;
                    padding: 10px 0;
                    border-bottom: 1px solid #f5f5f5;
                    font-size: 13px;
                }
                .account-row:last-child { border-bottom: none; }
                .section-title {
                    font-size: 11px; font-weight: 700; color: #aaa;
                    text-transform: uppercase; letter-spacing: 1px;
                    margin: 0 0 14px 0;
                }
            `}</style>

            <ContentWrapper>
                <div className="row g-4">

                    {/* LEFT — Profile Card */}
                    <div className="col-12 col-lg-5 col-xl-4">
                        <div className="profile-card card">
                            <div className="profile-banner" />
                            <div className="px-4 pb-4" style={{ marginTop: "-20px" }}>
                                <div className="d-flex align-items-end justify-content-between">
                                    <div className="profile-avatar-wrap">
                                        {isLoading ? (
                                            <div className="avatar-initials" style={{ background: "#e0e0e0" }} />
                                        ) : imgError || !subagent?.subagent_foto ? (
                                            <div className="avatar-initials">{getInitials(subagent?.subagent_name)}</div>
                                        ) : (
                                            <img src={BASEURLS(subagent?.subagent_foto)} alt="Profile" className="profile-avatar" onError={() => setImgError(true)} />
                                        )}
                                        <label className="upload-overlay" htmlFor="subagent_foto" title="Change photo">
                                            <MdCloudUpload style={{ color: "white", fontSize: "16px" }} />
                                            <input type="file" id="subagent_foto" name="subagent_foto" accept="image/*" onChange={(e) => setFile(e.target.files[0])} />
                                        </label>
                                    </div>
                                    <div className="badge-active mb-2"><MdVerified /> Active</div>
                                </div>

                                {isLoading ? (
                                    <div className="mt-3">
                                        <SkeletonBlock width="60%" height="22px" />
                                        <SkeletonBlock width="40%" height="14px" />
                                    </div>
                                ) : (
                                    <div className="mt-2">
                                        <h5 style={{ fontWeight: 700, color: "#222", margin: 0 }}>{subagent?.subagent_name}</h5>
                                        <p style={{ color: "#888", fontSize: "13px", margin: "2px 0 0 0" }}>Sub Agent · ID #{subagentid?.slice(0, 8)}</p>
                                    </div>
                                )}

                                <hr style={{ margin: "18px 0 8px", borderColor: "#f0f0f0" }} />
                                <p className="section-title">Contact Information</p>

                                {isLoading ? (
                                    <>
                                        <SkeletonBlock height="50px" radius="10px" />
                                        <SkeletonBlock height="50px" radius="10px" />
                                        <SkeletonBlock height="50px" radius="10px" />
                                    </>
                                ) : (
                                    <>
                                        <div className="info-row">
                                            <div className="info-icon" style={{ background: "#e3f5f5", color: "#4e9191" }}><FaUserCircle /></div>
                                            <div>
                                                <p className="info-label">Full Name</p>
                                                <p className="info-value">{subagent?.subagent_name || "—"}</p>
                                            </div>
                                        </div>
                                        <div className="info-row">
                                            <div className="info-icon" style={{ background: "#e8f5e9", color: "#0e7c52" }}><MdPhone /></div>
                                            <div>
                                                <p className="info-label">Mobile Number</p>
                                                <p className="info-value">{subagent?.subagent_mobile || "—"}</p>
                                            </div>
                                        </div>
                                        <div className="info-row">
                                            <div className="info-icon" style={{ background: "#f3e5f5", color: "#c779db" }}><MdEmail /></div>
                                            <div>
                                                <p className="info-label">Email Address</p>
                                                <p className="info-value">{subagent?.subagent_email || "—"}</p>
                                            </div>
                                        </div>
                                        <div className="info-row">
                                            <div className="info-icon" style={{ background: "#fff8e1", color: "#f59e0b" }}><MdAccessTime /></div>
                                            <div>
                                                <p className="info-label">Last Login</p>
                                                <p className="info-value">{subagent?.subagent_last_login || "—"}</p>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT — Account Details + Tips */}
                    <div className="col-12 col-lg-7 col-xl-8">

                        {/* Account Details */}
                        <div className="right-card card">
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <div style={{ width: 36, height: 36, borderRadius: 10, background: "#e3f5f5", display: "flex", alignItems: "center", justifyContent: "center", color: "#4e9191", fontSize: 18 }}>
                                    <FaShieldAlt />
                                </div>
                                <p className="section-title" style={{ margin: 0 }}>Account Details</p>
                            </div>
                            {accountDetails.map((item, i) => (
                                <div className="account-row" key={i}>
                                    <span style={{ color: "#888", fontWeight: 500 }}>{item.label}</span>
                                    <span style={{ color: "#333", fontWeight: 600 }}>{item.value}</span>
                                </div>
                            ))}
                        </div>

                        {/* Security Tips */}
                        <div className="right-card card">
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <div style={{ width: 36, height: 36, borderRadius: 10, background: "#fff8e1", display: "flex", alignItems: "center", justifyContent: "center", color: "#f59e0b", fontSize: 18 }}>
                                    <MdTipsAndUpdates />
                                </div>
                                <p className="section-title" style={{ margin: 0 }}>Tips & Reminders</p>
                            </div>
                            {tips.map((tip, i) => (
                                <div className="tip-item" key={i}>
                                    <div className="tip-icon" style={{ background: `${tip.color}18`, color: tip.color }}>
                                        {tip.icon}
                                    </div>
                                    <p style={{ fontSize: "13px", color: "#555", margin: 0, lineHeight: "1.5" }}>{tip.text}</p>
                                </div>
                            ))}
                        </div>

                        {/* Quick Actions */}
                        <div className="right-card card">
                            <p className="section-title">Quick Actions</p>
                            <div className="d-flex gap-3 flex-wrap">
                                {[
                                    { label: "View Orders", bg: "#4e9191", link: "/orders" },
                                    { label: "Dashboard", bg: "#0e7c52", link: "/dashboard" },
                                    { label: "Change Photo", bg: "#c779db", action: () => document.getElementById('subagent_foto').click() },
                                ].map((btn, i) => (
                                    <button key={i}
                                        onClick={btn.action || (() => navigate(btn.link))}
                                        style={{
                                            background: btn.bg,
                                            color: "white",
                                            border: "none",
                                            borderRadius: "10px",
                                            padding: "10px 20px",
                                            fontSize: "13px",
                                            fontWeight: 600,
                                            cursor: "pointer",
                                            transition: "all 0.2s",
                                            boxShadow: `0 4px 12px ${btn.bg}44`
                                        }}
                                        onMouseOver={e => e.target.style.transform = "translateY(-2px)"}
                                        onMouseOut={e => e.target.style.transform = "translateY(0)"}
                                    >
                                        {btn.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default withAuth(MyProfile)